import { create } from 'zustand';

type DirtyState = {
  isDirty: boolean;
  setDirty: (v: boolean) => void;
};

export const useDirtyStore = create<DirtyState>()((set) => ({
  isDirty: false,
  setDirty: (v) => set({ isDirty: v }),
}));
